import CustomBanner from "@components/CustomBanner";
import { Head } from "vite-react-ssg";
import BannerImage from "@assets/images/High-fidelity-ui-design.avif";
import { motion } from "framer-motion";
import GetAQuoteButton from "@components/GetAQuoteButton";
import FrostedContainer from "../../../../components/FrostedContainer";
export const Banner = () => {
  return (
    <>
      <Head>
        <title>Native Mobile App Development Company in DMV area</title>
        <meta
          name="description"
          content="Native app development services for DC-Maryland-Virginia and across USA. We build high-performance iOS and Android applications with native user-experiences."
        />
        <link
          rel="canonical"
          href="https://apptalyst.com/native-app-development"
        />
      </Head>
      <CustomBanner 
        bgImg={BannerImage}
                    customHeight={true}
         BannerImageAlt="A high-fidelity UI/UX design showing the skeleton, important components and work-flow of a website."
      >
       
            <FrostedContainer>

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true, amount: 0.3 }}
          >
            <h1 className="text-[30px] md:text-[38px] lg:text-[47px] xl:text-[52px] 2xl:text-[67px]  leading-[1] font-bold ">
              Top Native Mobile Application Development Company in DMV area{" "}
            </h1>
          </motion.div>
          <p className="text-base leading-[1.625rem] font-semibold text-white ">
            Building high-performance native apps that feel premium on every
            device. From high-growth startups to established enterprises, we
            build native iOS and Android solutions designed for zero performance
            compromises and hardware-level precision.
          </p>
          <div className="">
            <GetAQuoteButton title='Get Free Quote' text="Get Free Quote" />
          </div>
            </FrostedContainer>

       </CustomBanner>
    </>
  );
};
